import { QueryKeysAndFnOptions } from '../../../useQueryKeysAndFnToCache.types';
import { OfflineImageCacheManager } from '../../offlineImageCacheManager';
import { QueryKeysAndFnGenerator, QueryKeysAndFnGeneratorParams } from './types';
import { getImageResponseToCache } from './utils/getImageResponseToCache.util';

export class ImagesQueryKeysAndFnGenerator implements QueryKeysAndFnGenerator {
  constructor(
    private readonly params: Pick<QueryKeysAndFnGeneratorParams, 'priority' | 'userTeam'>,
  ) {}

  async generateQueryKeysAndFn(): Promise<QueryKeysAndFnOptions> {
    const offlineImageCacheManager = await OfflineImageCacheManager.create();

    if (!offlineImageCacheManager) {
      return [];
    }

    const queryKeysToBrandLogos = await this.getQueryKeysToBrandLogos(offlineImageCacheManager);

    return [...queryKeysToBrandLogos];
  }

  private async getQueryKeysToBrandLogos(
    cacheManager: OfflineImageCacheManager,
  ): Promise<QueryKeysAndFnOptions> {
    const { brand } = this.params.userTeam;
    const brandLogos = [brand?.logoUrl, brand?.logos?.wide].filter(
      (logoUrl): logoUrl is string => !!logoUrl,
    );

    return brandLogos.map((brandLogo) => ({
      priority: this.params.priority,
      useReactQuery: false,
      queryKey: ['images', brandLogo],
      queryFn: async () => {
        const responseToCache = await getImageResponseToCache(brandLogo);

        if (!responseToCache) {
          return;
        }

        await cacheManager.cacheResponse(brandLogo, responseToCache);
      },
    }));
  }
}
